import LicenseDetailsTrafficUsage from './LicenseDetailsTrafficUsage';

export default LicenseDetailsTrafficUsage;
